import React from 'react';

type AppPageSkeletonProps = {
  variant?: 'desktop' | 'mobile';
};

const ShimmerOverlay = () => (
  <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none" />
);

const AppPageSkeleton: React.FC<AppPageSkeletonProps> = ({ variant = 'desktop' }) => {
  const isDesktop = variant === 'desktop';
  const cardCount = isDesktop ? 6 : 4;

  return (
    <div
      role="status"
      aria-label="Loading page"
      className={`w-full bg-[#FFFFFF] font-raleway relative overflow-hidden ${
        isDesktop ? 'min-h-screen pt-16 px-6' : 'min-h-screen pt-14 px-4'
      }`}
    >
      <ShimmerOverlay />
      <div className={`mx-auto ${isDesktop ? 'max-w-[1200px]' : 'w-full'} py-6`}>
        <div className={`h-8 bg-gray-200/70 rounded animate-pulse mb-2 ${isDesktop ? 'w-64' : 'w-48'}`} />
        <div className={`h-4 bg-gray-200/70 rounded animate-pulse mb-8 ${isDesktop ? 'w-96' : 'w-full'}`} />
        <div
          className={`grid gap-4 ${
            isDesktop ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1'
          }`}
        >
          {Array.from({ length: cardCount }).map((_, index) => (
            <div
              key={index}
              className="border border-[#E9E9E9] rounded-xl overflow-hidden bg-white shadow-sm"
            >
              <div className={`bg-gray-200/70 animate-pulse ${isDesktop ? 'h-40' : 'h-32'}`} />
              <div className="p-4 space-y-3">
                <div className="h-5 bg-gray-200/70 rounded w-3/4 animate-pulse" />
                <div className="h-3 bg-gray-200/70 rounded w-full animate-pulse" />
                <div className="h-3 bg-gray-200/70 rounded w-5/6 animate-pulse" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <span className="sr-only">Loading page...</span>
    </div>
  );
};

export default AppPageSkeleton;
